import { SORT_BY_PRICE_LOW_TO_HIGH } from '../product-grid/constants';

const sortByPrice = (items, option) =>
  items.sort((a, b) =>
    option === SORT_BY_PRICE_LOW_TO_HIGH
      ? (a.variants[0].compareAtPrice.amount || a.variants[0].price.amount) -
        (b.variants[0].compareAtPrice.amount || b.variants[0].price.amount)
      : (b.variants[0].compareAtPrice.amount || b.variants[0].price.amount) -
        (a.variants[0].compareAtPrice.amount || a.variants[0].price.amount),
  );

export default sortByPrice;
